@let currentField = field();

<div class="filter-card-field-input d-flex align-items-center gap-2">
  @switch (currentField.type) {
    @case ('dateRange') {
      <app-date-range-picker
        [formControl]="control"
        [configurationInput]="currentField.configuration"
        (datesChangedByCalendar)="onDatesChange($event)"
      ></app-date-range-picker>
    }
    @case ('dropdown') {
      <mat-dropdown
        [options]="currentField.options()"
        [configurationInput]="currentField.configuration"
        [formControl]="control"
        (search)="currentField.onSearch && currentField.onSearch($event, control.value ?? [])"
      ></mat-dropdown>
    }
    @case ('buttonToggle') {
      <mat-button-toggle-group
        [formControl]="control"
        [attr.aria-label]="currentField.ariaLabel"
        [hideSingleSelectionIndicator]="true"
      >
        @for (option of currentField.options; track option.value) {
          <mat-button-toggle [value]="option.value">{{ option.labelKey | translate }}</mat-button-toggle>
        }
      </mat-button-toggle-group>
    }
  }

  @if (shouldSuppressAutoCommit()) {
    <button mat-mini-fab type="button" [attr.aria-label]="'button.add' | translate" (click)="submit()">
      <mat-icon>check</mat-icon>
    </button>
  }

  <button mat-mini-fab type="button" [attr.aria-label]="'button.cancel' | translate" (click)="dismissed.emit()">
    <mat-icon>close</mat-icon>
  </button>
</div>
